import React from 'react'
import HeroImg from '../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../components/Constant/button/Button";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import CTA from "../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function IsleManCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Isle of Man Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate in a Zero-Tax, Tier-1 European Jurisdiction</h3>
                            <p className='page-paragraph'>
                                An <b> Isle of Man company</b> provides <b> credibility, tax neutrality, and investor confidence.</b> With <b>0% corporate tax (except banking and land income),</b> it is one of the most attractive business jurisdictions for <b> entrepreneurs, HNWIs, and multinational groups.</b>
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Zero Corporate Tax",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Strong Banking Access",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Global Credibility",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "EU/UK Proximity",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request an Isle of Man Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Incorporate in the Isle of Man?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Tier-1 Reputation",
                                    paragraph: "Globally recognized as a secure financial center",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Zero Corporate Tax",
                                    paragraph: "Except for banking (10%) and local land/property (20%)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investor Confidence",
                                    paragraph: "Preferred by banks, investors, and regulators",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Proximity to UK/EU",
                                    paragraph: "Great base for European operations",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Structures",
                                    paragraph: "Used for fintech, e-commerce, shipping, and funds",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Types of Companies in the Isle of Man
                        </h3>
                        <p className='page-subtitle'>1. Private Company Limited by Shares (LTD)</p>
                        <PageList
                            items={[
                                { paragraph: "Most common structure.", icon: GoDotFill },
                                { paragraph: "Suitable for trading, e-commerce, holding, and fintech.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. Public Company (PLC)</p>
                        <PageList
                            items={[
                                { paragraph: "For large enterprises or capital raising.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>3. Limited Liability Company (LLC)</p>
                        <PageList
                            items={[
                                { paragraph: "US-style pass-through taxation.", icon: GoDotFill },
                                { paragraph: "Often used for joint ventures.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>4. Protected Cell & Incorporated Cell Companies (PCC/ICC)</p>
                        <PageList
                            items={[
                                { paragraph: "Special structures for insurance and fund management.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>5. Limited Partnerships (LP)</p>
                        <PageList
                            items={[
                                { paragraph: "Common in funds and asset management.", icon: GoDotFill },
                            ]}
                        />

                        <hr className='section-divider'/>

                        <h3 className='page-title'>
                            Incorporation Requirements
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders",
                                    paragraph: "At least 1",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "At least 1 (individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registered Office",
                                    paragraph: "Must be in the Isle of Man",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Secretary",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Minimum Share Capital",
                                    paragraph: "None (commonly GBP 1)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Filing",
                                    paragraph: "Annual return & accounts (audit thresholds apply)",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Benefits of Isle of Man Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "0% Corporate Tax",
                                    paragraph: "For most companies",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regulated & Respected",
                                    paragraph: "Tier-1 status with global banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Access",
                                    paragraph: "Easier than most offshore centers",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strong for Funds/Insurance",
                                    paragraph: "PCC/ICC structures",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Stable Legal System",
                                    paragraph: "Based on English common law",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Process
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Planning",
                                    paragraph: "Choose structure (LTD, LLC, PCC, etc.)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Check availability",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Preparation",
                                    paragraph: "Memorandum & Articles of Association",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Filing",
                                    paragraph: "With the Isle of Man Companies Registry",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Certificate of Incorporation issued",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account Setup",
                                    paragraph: "Local or international",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "5–10 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From GBP 4,500+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Registered office, filings, accounting/audit if required",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Common Uses of Isle of Man Companies</h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "E-commerce & FinTech startups",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Holding companies for assets, shares, or IP",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Insurance vehicles (PCC/ICC)",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Investment funds & partnerships",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Shipping & aviation ownership",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in IoM company incorporation & licensing",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Network of law firms, auditors, and fiduciaries on the island",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Expertise in insurance, funds, and fintech structures",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "Isle of Man vs Gibraltar vs Malta vs Jersey",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Long-term compliance, audit & accounting support",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a Tier-1 offshore jurisdiction with zero tax?"
                        description="The <b>Isle of Man</b> combines tax neutrality, EU/UK proximity, and global credibility."
                        buttonText="Book an Isle of Man Company Formation Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default IsleManCompanyFormation

const faqData = [
    {
        question: "Do Isle of Man companies pay tax?",
        content: [
            { type: "answer", text: "No — 0% corporate tax (except banking 10%, property income 20%)." },
        ],
    },
    {
        question: "Can foreigners own 100%?",
        content: [
            { type: "answer", text: "Yes — full foreign ownership is allowed." },
        ],
    },
    {
        question: "Do companies need audits?",
        content: [
            { type: "answer", text: "Only if turnover/assets exceed thresholds; smaller companies may be exempt." },
        ],
    },
    {
        question: "Is there a minimum capital requirement?",
        content: [
            { type: "answer", text: "No — can be incorporated with GBP 1." },
        ],
    },
    {
        question: "How long does incorporation take?",
        content: [
            { type: "answer", text: "Usually 5–10 business days." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
        "We used an Isle of Man company for our fintech venture. Offshore Advisory provided incorporation, banking, and compliance support.",
        author: "James L.",
        role: "FinTech Entrepreneur",
    },
    {
        quote:
            "Our investment fund was structured in the Isle of Man as a PCC. Offshore Advisory guided us through licensing and incorporation.",
        author: "Clara V.",
        role: "Fund Manager",
    },
];